import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ['mobileBtn', 'closeBtn', 'menu', 'dropdownToggle', 'searchBar', 'searchIcon', 'search']

    connect() {
        if (this.hasSearchBarTarget) {
            this.searchBarTarget.style.display = 'none';
            this.searchIconTarget.style.backgroundColor = '#E2D6E4';
        }

        this.element.querySelectorAll('.dropdown-content').forEach(dropdown => {
            dropdown.classList.add('hidden');
        });

        this.element.querySelectorAll('.dropdown-toggle svg').forEach(arrow => {
            arrow.style.transform = 'rotate(0deg)';
        });
    }

    toggleSearchBar(e) {
        if (!this.hasSearchBarTarget || !this.hasSearchIconTarget) return;
        
        const isHidden = this.searchBarTarget.style.display === 'none';
        this.searchBarTarget.style.display = isHidden ? 'block' : 'none';
        
        const searchIconContainer = this.searchIconTarget;
        
        const searchIcon = searchIconContainer.querySelector('.search-icon');
        const closeIcon = searchIconContainer.querySelector('.close-icon');
        
        if (isHidden) {
            searchIconContainer.style.backgroundColor = '#541E63';
            searchIcon.classList.add('hidden');
            closeIcon.classList.remove('hidden');
            closeIcon.querySelector('svg').style.color = 'white';
            searchIconContainer.style.top = '0';
            searchIconContainer.style.height = '70px';
            closeIcon.style.paddingBottom = '15px';


        } else {
            searchIconContainer.style.backgroundColor = '#E2D6E4';
            searchIcon.classList.remove('hidden');
            closeIcon.classList.add('hidden');
            searchIconContainer.style.height = '48px'
        }
    }

    toggleMenu() {
        if (window.innerWidth < 1024 && this.hasSearchBarTarget && this.hasSearchIconTarget) {
            this.searchBarTarget.style.display = 'none';
            
            const searchIconContainer = this.searchIconTarget;
            const searchIcon = searchIconContainer.querySelector('.search-icon');
            const closeIcon = searchIconContainer.querySelector('.close-icon');
            
            searchIconContainer.style.backgroundColor = '#E2D6E4';
            searchIcon.classList.remove('hidden');
            closeIcon.classList.add('hidden');
            searchIconContainer.style.height = '48px';
        }

        this.element.querySelectorAll('.dropdown-content').forEach(dropdown => {
            dropdown.classList.add('hidden');
        });
    
        this.element.querySelectorAll('.dropdown-toggle svg').forEach(arrow => {
            arrow.style.transform = 'rotate(0deg)';
        });
    
        const isHidden = this.menuTarget.classList.contains('hidden');
        this.menuTarget.classList.toggle('hidden');
    
        document.body.style.overflow = isHidden ? 'hidden' : 'auto';
        
        const backToTopContainer = document.getElementById('back-to-top-container');
        if (backToTopContainer) {
            backToTopContainer.classList.toggle('hidden', isHidden);
        }
    }

    toggleDropdown(event) {
        event.preventDefault();
        event.stopPropagation();
            
        const toggle = event.currentTarget;
        const menuItem = toggle.closest('.mobile-menu-item');
        if (!menuItem) return;

        const dropdownContent = menuItem.querySelector('.dropdown-content');
        const arrow = toggle.querySelector('svg');
            
        if (dropdownContent && arrow) {
            dropdownContent.classList.toggle('hidden');
            arrow.style.transform = dropdownContent.classList.contains('hidden') 
                ? 'rotate(0deg)' 
                : 'rotate(180deg)';
        }
    }

    toggleSearch() {
        if (this.hasSearchTarget) {
            const isHidden = this.searchTarget.classList.contains('hidden');
            this.searchTarget.classList.toggle('hidden');
            document.body.style.overflow = isHidden ? 'hidden' : 'auto';
        }
    }

}          